import React, { useEffect, useState } from 'react';
import { Box, Button, MenuItem, Switch, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import Modal from '../../../components/Modals/Modal';
import { CustomTextField } from '../../../components/Textfield';
import {
    addCapacityApprover,
    editCapacityApprover,
    GetOrgs,
} from '../../../store/actions/settingsActionCreator';
import { showMessage } from '../../../utils/helper';

function AddEditApproverModal({
    open,
    data,
    orgId: defaultOrgId,
    orgList,
    onClose,
    dispatchAddCapacityApprover,
    dispatchEditCapacityApprover,
    dispatchGetOrgs,
}) {
    const isEdit = !!data?.id;
    const [loading, setLoading] = useState(false);
    const [contactNumber, setContactNumber] = useState(data?.phone ?? '');
    const [selectedOrgId, setSelectedOrgId] = useState(data?.orgId ?? defaultOrgId);
    const [email, setEmail] = useState(data?.email ?? '');
    const [isActive, setIsActive] = useState(data?.isActive ?? true);

    useEffect(() => {
        if (!isEdit) {
            dispatchGetOrgs();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        !!onClose && onClose();
    };

    const handleSubmit = () => {
        setLoading(true);
        const payload = {
            orgId: selectedOrgId,
            contactNumber,
            email,
            isActive,
        };
        const dispatchFn = isEdit
            ? (onSuccess, onError) =>
                  dispatchEditCapacityApprover(data.id, payload, onSuccess, onError)
            : (onSuccess, onError) =>
                  dispatchAddCapacityApprover(payload, onSuccess, onError);
        dispatchFn(
            () => {
                setLoading(false);
                showMessage(
                    isEdit ? 'Approver updated' : 'Approver added',
                    'success',
                );
                handleClose();
            },
            () => {
                setLoading(false);
            },
        );
    };

    const actions = [
        <Button
            key={1}
            variant="contained"
            color="default"
            className="cancelButton"
            onClick={handleClose}
            disableElevation
        >
            Cancel
        </Button>,
        <Button
            key={2}
            variant="contained"
            color="primary"
            className="saveButton"
            onClick={handleSubmit}
            disableElevation
        >
            Save
        </Button>,
    ];

    return (
        <Modal
            onClose={handleClose}
            open={open}
            title={isEdit ? 'Edit Approver' : 'Add Approver'}
            subtitle="Only approver-deciders can change this. FM, SFM and Super Admin come from StaffPay role assignments and can't be added here."
            actions={actions}
            loading={loading}
            maxWidth="xs"
        >
            <CustomTextField
                fullWidth
                label="Tier"
                value="Approver"
                disabled
                style={{ marginBottom: 16 }}
            />
            <CustomTextField
                fullWidth
                label="Contact Number"
                value={contactNumber}
                onChange={(e) => setContactNumber(e.target.value)}
                disabled={isEdit}
                isRequired={!isEdit}
                style={{ marginBottom: 16 }}
            />
            {!isEdit && (
                <CustomTextField
                    fullWidth
                    label={!!selectedOrgId ? 'Organization' : 'Select Organization'}
                    select
                    value={selectedOrgId ?? ''}
                    onChange={(e) => setSelectedOrgId(e.target.value)}
                    style={{ marginBottom: 16 }}
                    isRequired
                >
                    {(orgList ?? []).length === 0 && <MenuItem value={undefined}>No Data found</MenuItem>}
                    {(orgList ?? []).map((org) => (
                        <MenuItem key={org.id} value={org.id}>
                            {org.name}
                        </MenuItem>
                    ))}
                </CustomTextField>
            )}
            <CustomTextField
                fullWidth
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ marginBottom: 16 }}
            />
            {isEdit && (
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body2">Active</Typography>
                    <Switch
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                </Box>
            )}
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    orgList: state?.settings?.orgs,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchAddCapacityApprover: (data, onSuccess, onError) =>
        dispatch(addCapacityApprover(data, onSuccess, onError)),
    dispatchEditCapacityApprover: (id, data, onSuccess, onError) =>
        dispatch(editCapacityApprover(id, data, onSuccess, onError)),
    dispatchGetOrgs: (onSuccess, onError) => dispatch(GetOrgs(onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEditApproverModal);
